<div class="bgm-white">
  <div class="container contacts">
    <div class="p-30 fx-row">
      <div class="bg-white-smoke fx-col gt-sm-fx-row fx-main-center fx-cross-center fx-fill-size fx-flex">
        <div class="fx-col fx-main-center fx-cross-stretch fx-fill-size lt-md-fx-flex-100-in-col gt-sm-fx-flex-50 print-fx-flex-50-in-col">
          <img
            src="https://cdn.shopify.com/s/files/1/0926/9298/files/NEWBLACKOUTLEGGINGS_NAVY_1_085ee5dc-7e45-4d27-8a72-d75f18d4bb01_1080x.jpg?v=1600985773"
            alt="product-image" width="100%">
        </div>
        <div class="fx-col fx-main-center fx-cross-center fx-fill-size lt-md-fx-flex-100-in-col gt-sm-fx-flex-50 print-fx-flex-50-in-col">
          <div class="content p-30 fx-col fx-main-center fx-cross-stretch fx-flex-50-in-col lt-md-fx-flex-100-in-col">
            <p class="m-t-12 f-s-36 f-w-700">Say Hello!</p>
            <p class="m-t-20">We're available regular office hours to discuss our products. We're always looking to hear from our customers — it's how we develop our products and know that we're doing a good job. Our office hours are Monday to Friday, 10AM to 6PM, and we usually response within a single business day.</p>
          </div>
          <div class="p-30 fx-row fx-main-center fx-cross-stretch fx-flex-50-in-col lt-md-fx-flex-100-in-col">
            <div   class="contact-form fx-flex-100 sm-fx-flex-50">
              <form class="fx-row-wrap">
                <div [appBreakpointClass]="{'sm':'mt-1','xs':'mt-1'}" class="px-1 fx-flex-100">
                  <mat-form-field class="w-100 ds-validate design"  appearance="outline">
                    <mat-label translate="user_first_name"></mat-label>
                    <input matInput [(ngModel)]="contact.FirstName" [ngModelOptions]="{standalone: true}" name="FirstName"
                      validate noempty="true">
                  </mat-form-field>
                </div>
                <div [appBreakpointClass]="{'sm':'mt-1','xs':'mt-1'}" class="px-1 fx-flex-100">
                  <mat-form-field class="w-100 ds-validate design" appearance="outline">
                    <mat-label translate="user_last_"></mat-label>
                    <input matInput [(ngModel)]="contact.LastName" [ngModelOptions]="{standalone: true}" name="LastName"
                      validate noempty="true">
                  </mat-form-field>
                </div>
                <div [appBreakpointClass]="{'sm':'mt-1','xs':'mt-1'}" class="px-1 fx-flex-100">
                  <mat-form-field class="w-100 ds-validate design" appearance="outline">
                    <mat-label translate="MobilePhone_"></mat-label>
                    <input matInput [(ngModel)]="contact.MobilePhone" [ngModelOptions]="{standalone: true}" name="Phone"
                      phoneno="true" inputspace="true" validate noempty="true" maxlength="20" inputonlynumber="true">
                  </mat-form-field>
                </div>
                <div [appBreakpointClass]="{'sm':'mt-1','xs':'mt-1'}" class="px-1 fx-flex-100">
                  <mat-form-field class="w-100 ds-validate design" appearance="outline">
                    <mat-label translate="email_"></mat-label>
                    <input matInput [(ngModel)]="contact.Email" [ngModelOptions]="{standalone: true}" name="email"
                      validate noempty="true" email="true">
                  </mat-form-field>
                </div>
                <div [appBreakpointClass]="{'sm':'mt-1','xs':'mt-1'}" class="px-1 fx-flex-100">
                  <mat-form-field class="w-100 ds-validate" appearance="outline">
                    <mat-label translate="message_"></mat-label>
                    <textarea matInput rows="6" [(ngModel)]="contact.Message" [ngModelOptions]="{standalone: true}"
                    name="content"></textarea>
                  </mat-form-field>
                </div>
                <div [appBreakpointClass]="{'sm':'mt-1','xs':'mt-1'}" class="px-1 fx-flex-100">
                  <mat-form-field class="w-100 ds-validate fx-row-in-form-field" appearance="none">
                    <div class="fx-col fx-flex-100">
                      <div class="fx-row fx-main-between fx-cross-stretch fx-flex-100-in-col">
                        <div class="captcha_code fx-flex-56 xs-fx-flex-63" id="captcha_code">
                          <span translate>captcha_</span><span id="captchaQuestion"></span><span> = </span>
                        </div>
                        <div class="captcha_answer m-r-10 fx-flex-39 xs-fx-flex-30">
                          <input matInput id="answer" inputonlynumber="true" validate noempty="true"
                            [(ngModel)]="contact.result" (focusout)="checkCaptch()" [ngModelOptions]="{standalone: true}" name="answer" type="text" >
                        </div>
                      </div>
                      @if (!captchaError) {
                        <div class="captchaError">
                          <small class="has-error help-block" translate>enter_valid_captcha</small>
                        </div>
                      }
                      <div class="reload_captcha">
                        <span translate>reload_captcha</span><span><img src="/assets/images/arrow.png"
                      [default]="'assets/images/noimage.png'" (click)="getRandom(true)"></span>
                    </div>
                  </div>
                </mat-form-field>
              </div>
              <div class="button-wrap" [appBreakpointClass]="{'sm':'mt-1','xs':'mt-1'}" class="px-1 fx-flex-100">
                <button class="btn-project shop-btn product-button" mat-raised-button color="black"validate trigger-check="true"
                (success)="contactUser()">{{'_submit'| translate}}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>